import React from 'react';
import Form from 'jl-design-system/components/form/Form';
import { QUANTITY_INPUT } from 'jl-design-system/form/fields';
// lodash
import isEmpty from 'lodash/isEmpty';
import getItemQuantityFormConfig from '../../utils/form/configs/itemQuantity';
import isItemFabric from '../../utils/orderform/isItemFabric';

export function getQuantitySelector(item, reducedQuantity) {
  const config = getItemQuantityFormConfig({
    item,
    isItemFabric: isItemFabric(item),
    maxValue: item.availability.stockLevel,
  });

  return (
    <Form
      config={config}
      data-test="order-item-quantity-selector"
      form={config.id}
      initialValues={{
        [QUANTITY_INPUT.id]: reducedQuantity.toString(),
        itemId: item.id,
      }}
      useFormValidationErrorsAlertMessage={false}
    />
  );
}

export function getReducedQuantityText(quantity, reducedQuantity, styles) {
  return (
    <div className={styles.reducedQuantity}>
      <span data-test="order-item-unavailable-quantity">
        <span>Quantity: </span>
        <span className={styles.strikeThrough}>{quantity}</span>
      </span>
      <span data-test="order-item-available-quantity">{reducedQuantity}</span>
    </div>
  );
}

export function getReducedQuantityTextForFabricItem(quantity, reducedQuantity, styles) {
  return (
    <div className={styles.reducedQuantity}>
      <span>Quantity: </span>
      <span
        className={styles.strikeThrough}
        data-test="order-item-unavailable-quantity"
      >
        {quantity}
      </span>
      <span data-test="order-item-available-quantity">{reducedQuantity}</span>
      <span>metre(s)</span>
    </div>
  );
}

export function getQuantityText(quantity, styles) {
  return (
    <div className={styles.quantity}>
      <span
        className={styles.visuallyHiddenText}
        data-test="order-item-quantity-reference"
      >
        Quantity: {quantity}
      </span>

      <p
        aria-hidden="true"
        data-test="order-item-quantity"
      >
        Quantity: {quantity}
      </p>
    </div>
  );
}

export function getQuantityTextFabricItem(quantity, styles) {
  // TODO simplify this
  const quantityLabel = quantity === 1 ?
    `Quantity: ${quantity} metre` : `Quantity: ${quantity} metres`;
  const quantityReferenceLabel = quantity === 1 ?
    `Quantity ${quantity} metre` : `Quantity ${quantity} metres`;

  return (
    <div className={styles.quantity}>
      <span
        className={styles.visuallyHiddenText}
        data-test="order-item-quantity-reference"
      >
        {quantityReferenceLabel}
      </span>

      <p
        aria-hidden="true"
        data-test="order-item-quantity"
      >
        {quantityLabel}
      </p>
    </div>
  );
}

export function getInformationList(information, styles) {
  if (isEmpty(information)) {
    return null;
  }

  return (
    <dl className={styles.informationList} data-test="order-item-information-list">
      {information.map(infoItem => (
        <div key={infoItem.name} className={styles.informationListItem}>
          <dt className={styles.informationListItemTerm}>
            {infoItem.name}:{' '}
          </dt>
          <dd className={styles.informationListItemDefinition}>{infoItem.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function getSubtotalText(
  partnerDiscount,
  partnerDiscountEnabled,
  sidebar,
  subtotal,
  subtotalDiscounted,
  styles,
  reducedToClear,
  originalSubtotal,
  basketView,
) {

  return (

    <span
      className={(!sidebar && partnerDiscountEnabled && subtotalDiscounted !== undefined) || reducedToClear ?
        `${styles.subtotal} ${styles.withDiscount}` : styles.subtotal}
      data-test="get-subtotal-text-container"
    >

      {
        !basketView && (!partnerDiscountEnabled || subtotalDiscounted === undefined) && !reducedToClear &&
        <>
          <span
            className={styles.visuallyHiddenText}
            data-test="order-item-subtotal-label"
          >
            Subtotal
          </span>

          <p data-test="order-item-subtotal-value">{subtotal}</p>
        </>
      }

      {
        basketView &&
        <p data-test="order-item-subtotal-value">{subtotalDiscounted || subtotal}</p>
      }

      {
        !basketView && (reducedToClear && originalSubtotal !== undefined) &&
        <>
          <div className={styles.discountedPriceContainer} data-test="order-item-discounted-price-container">
            <span
              className={styles.visuallyHiddenText}
              data-test="order-item-subtotal-label"
            >
              Subtotal
            </span>
            <p
              className={styles.strikeThrough}
              data-test="order-item-subtotal-value"
            >
              {originalSubtotal}
            </p>

            <span
              className={styles.visuallyHiddenText}
              data-test="order-item-discounted-subtotal-label"
            >
              Subtotal with partner discount applied
            </span>
            <p
              className={styles.reducedToClearSubtotal}
              data-test="order-item-discounted-subtotal-value"
            >
              {subtotal}
            </p>
          </div>
          <span
            className={styles.reducerToClearText}
            data-test="reduced-to-clear-text"
          >
            Reduced to clear
          </span>
        </>
      }

      {
        !basketView && (partnerDiscountEnabled && subtotalDiscounted !== undefined) &&
        <>
          <div data-test="order-item-partner-discounted-price-container">
            <span
              className={styles.visuallyHiddenText}
              data-test="order-item-subtotal-label"
            >
              Subtotal
            </span>
            <div className={styles.discountedPriceContainer}>
              <p
                className={styles.strikeThrough}
                data-test="order-item-subtotal-value"
              >
                {subtotal}
              </p>
              <span
                className={styles.visuallyHiddenText}
                data-test="order-item-discounted-subtotal-label"
              >
                Subtotal with partner discount applied
              </span>
              <p
                className={styles.discountedSubtotal}
                data-test="order-item-discounted-subtotal-value"
              >
                {subtotalDiscounted}
              </p>
            </div>
            <p className={styles.discountAmount} data-test="order-item-discount-amount-value">
              ({partnerDiscount}<span> discount</span>)
            </p>
          </div>
        </>
      }
    </span>
  );

}
